import type { FaireReviewEntity } from "../../entity_types/review";

// Real Softies review, read off the brand's public Faire product-reviews API
// (Ryan, 2026-09-02) — verbatim comment, real reviewer, real shop, real date.
// `review_sof*` prefix keeps these from colliding with another brand's files.
export const review_sof1: FaireReviewEntity = {
  token: "review_sof1",
  type: "review",
  brandName: "Softies",
  brandToken: "b_br6ji29u",
  reviewType: "product",
  productToken: "p_b8358pyb86",
  reviewerName: "Jacqui",
  reviewerLocation: "Stuart, FL",
  stars: 5,
  reviewText: "Absolutely wonderful!  These jackets are so soft and cozy and are the same on the inside.  Super versatile….if worn over a sweatshirt, they keep you warm in cold weather AND aren’t too heavy to be worn on cool days/nights.  The adjustable waist gives them a feminine touch too.  Highly recommend!",
  reviewDate: "Feb 10, 2026",
  meta: {
    source: "api",
    importedAt: "2026-09-02T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
